import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback, useEffect, useState } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from './useEntityRepository';

export function useEntityByIdOrOriginalId<TEntityName extends EntityName>(
  entityName: TEntityName,
  idOrOriginalId: string | null | undefined
): AppEntityManagerEntityTypesByEntityName[TEntityName]['entity'] | null {
  const repository = useEntityRepository(entityName) as EntityRepository<
    any,
    any,
    any
  >; // for performance reasons

  const queryEntity = useCallback(():
    | AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
    | null => {
    let entry:
      | AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
      | null = null;

    if (idOrOriginalId) {
      entry = repository.getById(idOrOriginalId);

      if (!entry) {
        entry = repository.getByOriginalId(idOrOriginalId);
      }
    }

    return entry;
  }, [idOrOriginalId, repository]);

  const [entity, setEntity] = useState(queryEntity);

  useEffect(() => {
    setEntity(queryEntity);
  }, [queryEntity]);

  return entity;
}
